var ZipAvailabilityProbabilityEnum;
(function (ZipAvailabilityProbabilityEnum) {
    ZipAvailabilityProbabilityEnum["highInStock"] = "HIGH_IN_STOCK";
    ZipAvailabilityProbabilityEnum["mediumInStock"] = "MEDIUM_IN_STOCK";
    ZipAvailabilityProbabilityEnum["lowInStock"] = "LOW_IN_STOCK";
    ZipAvailabilityProbabilityEnum["outOfStock"] = "OUT_OF_STOCK";
    ZipAvailabilityProbabilityEnum["notInRange"] = "NOT_IN_RANGE";
    ZipAvailabilityProbabilityEnum["notSoldTemp"] = "NOT_SOLD_TEMP";
})(ZipAvailabilityProbabilityEnum || (ZipAvailabilityProbabilityEnum = {}));
export default ZipAvailabilityProbabilityEnum;
//# sourceMappingURL=ZipAvailabilityProbabilityEnum.js.map